export default __webpack_public_path__ + "static/lizzard-4b7e26c81976b84c4cb29052a3f37d07.svg";